import React, {Component} from 'react'
import {Button, Collapse} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import {ProjectWriteoffInput} from "./ProjectWriteoffInput";
import ProjectWriteOffList from "./ProjectWriteoffList";
import upsertWriteoffMutation from '../../../queries/server/mutations/upsert_project_writeoff'
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_project'
import {
    checkPermission,
    PROJECTS_CAN_CREATE_WRITE_OFFS,
    PROJECTS_CAN_EDIT_WRITE_OFFS,
    PROJECTS_CAN_REMOVE_WRITE_OFFS
} from "../../../lib/permissions"

export default class ProjectWriteoffs extends Component {

    state = {
        showInput: false
    }

    add = () => {
        this.setState({showInput: !this.state.showInput})
    }

    render() {

        const {state} = this
        const {project_id, project, writeoffs} = this.props

        return (
            <div>
                <Button
                    size="sm"
                    color={state.showInput ? 'warning' : 'success'}
                    onClick={this.add}
                    disabled={!checkPermission(PROJECTS_CAN_CREATE_WRITE_OFFS)}
                >
                    <FontAwesomeIcon color="#fff" icon={state.showInput ? 'minus' : 'plus'}/>{' '}
                    {state.showInput ? 'Cancel' : 'Add Write Off'}
                </Button>

                <Collapse isOpen={state.showInput}>
                    <div className="d-flex flex-column pt-3 mt-3 card card-body bg-light">
                        <Mutation mutation={upsertWriteoffMutation}>
                            {(upsertWriteoffMutationFunc, {loading}) => (
                                <Mutation mutation={editProjectLocalMutation}>
                                    {(editProjectLocalMutationFunc) => (
                                        <ProjectWriteoffInput
                                            onCancel={() => this.setState({showInput: false})}
                                            loading={loading}
                                            budgets={project.project_activity_budgets}
                                            onAdd={(data) => {
                                                upsertWriteoffMutationFunc({
                                                    variables: {
                                                        data: {...data, project_id},
                                                        project_id
                                                    }
                                                })
                                                    .then(({data}) => {
                                                        toast.success('Write Off Added', {autoClose: 2000})
                                                        editProjectLocalMutationFunc({
                                                            variables: {
                                                                data: data.upsertProjectWriteoff
                                                            }
                                                        })
                                                        this.add()
                                                    })
                                                    .catch(e => toast.error(e.message, {autoClose: false}))
                                            }}
                                        />
                                    )}
                                </Mutation>
                            )}
                        </Mutation>
                    </div>
                </Collapse>

                <ProjectWriteOffList canEdit={checkPermission(PROJECTS_CAN_EDIT_WRITE_OFFS)}
                                     canRemove={checkPermission(PROJECTS_CAN_REMOVE_WRITE_OFFS)}
                                     project_id={project_id} project={project} writeoffs={writeoffs}/>
            </div>
        )
    }

}

ProjectWriteoffs.propTypes = {
    project: PropTypes.object.isRequired,
    project_id: PropTypes.string.isRequired,
    writeoffs: PropTypes.array,
}